// extracted by mini-css-extract-plugin
module.exports = {"container":"marquee-module--container--3p_31","containerImage":"marquee-module--containerImage--5MVdk","marquee":"marquee-module--marquee--3pluJ"};